module.exports = __webpack_public_path__ + "static/media/ilbc5.45d2d699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilbc5.jpg
// module id = 5803
// module chunks = 0